import { atom } from 'jotai';

/**
 * Image Generation Session State
 *
 * Tracks whether there's an active session and provides a way to
 * signal a reset request from outside the ImageGenerationPage.
 */
export interface ImageGenerationSessionState {
  /** Whether there's an active session (sessionId exists) */
  hasActiveSession: boolean;
  /** Counter that increments when a reset is requested */
  resetRequestCounter: number;
}

const initialState: ImageGenerationSessionState = {
  hasActiveSession: false,
  resetRequestCounter: 0,
};

/**
 * Atom for tracking image generation session state.
 *
 * Used by:
 * - RootLayout: To check if there's an active session and request resets
 * - ImageGenerationPage: To report session status and respond to reset requests
 */
export const imageGenerationSessionAtom =
  atom<ImageGenerationSessionState>(initialState);
